"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_draft_1 = require("@dzambalaorg/mui-inputs-draft");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const types_1 = require("@framework/types");
const inputs_1 = require("../../../../inputs");
const validation_1 = require("./validation");
const ProductDialogForm = (props) => {
    const { selectedItem, open, mode, ...rest } = props;
    if (!open || !selectedItem) {
        return null;
    }
    const { id, title, description, categories, productStatus } = selectedItem;
    const fixedValues = {
        id,
        title,
        description,
        parameters: [],
        productItems: [],
        productStatus,
        categoryIds: categories.map((category) => category.id),
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { open: open, initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: `dialogs.${mode}`, filter: ({ id: _id, ...rest }) => rest, ...rest, children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "title" }), (0, jsx_runtime_1.jsx)(mui_inputs_draft_1.RichTextEditor, { name: "description" }), (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "categoryIds", controller: "ecommerce/categories", multiple: true }), (0, jsx_runtime_1.jsx)(inputs_1.ParameterSelectInput, { multiple: true, prefix: "parameters" }), mode === "edit" && (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "productStatus", options: types_1.ProductStatus })] }));
};
exports.ProductDialogForm = ProductDialogForm;
//# sourceMappingURL=index.js.map